<template>
  <div 
    class="card"
    @mouseover="isHovered = true"
    @mouseleave="isHovered = false"
    :class="{ 'card-hover': isHovered }"
    @click="gotoPage"
  >
    <div class="card-image">
      <img :src="imageUrl" :alt="title" class="img-fluid">
    </div>
    <div class="card-content">
      <div class="card-title">{{ title }}</div>
      <p class="card-description">{{ description }}</p>
      <div class="card-date">{{ date }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogCard',
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    date: {
      type: [String, Date],
      default: ''
    },
    link: {
      type: [String, Object],
      default: ''
    }
  },
  data() {
    return {
      isHovered: false
    }
  },
  computed: {
    formattedDate() {
      if (!this.date) return '';
      
      const dateObj = new Date(this.date);
      return dateObj.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  methods: {
    getImage(name) {
      return require(`@/assets/uupay/images/${name}.png`)
    },
    gotoPage() {
      console.log('gotoPage:', this.link)
      this.$router.push(this.link);
      // 或者带参数
      // this.$router.push({ path: '/target-route', query: { id: 123 } });
      // this.$router.push({ name: 'routeName', params: { id: 123 } });
    }
  }
}
</script>

<style scoped>
.card {
  width: 280px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  background: white;
  /*margin: 16px;*/
  color: #21042e;
  cursor: pointer;
}

.card-hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
}

.card-image {
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card-hover .card-image img {
  transform: scale(1.05);
}

.card-content {
  padding: 18px;
}

.card-title {
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #21042e;
}

.card-description {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.card-date {
  font-size: 12px;
  line-height: 16px;
  color: #76667c;
  /*text-align: right;*/
}
</style>


// WEBPACK FOOTER //
// src/components/BlogCard.vue